import { useEffect } from 'react';
import Configurations from './settings';

declare global {
  interface Window {
    UET: any;
    uetq: any[];
    dataLayer: any[];
  }
}

const TrackingAndRedirects: React.FC = () => {
  useEffect(() => {
    const { pathname, href, origin } = window.location;
    const userAgent = window.navigator.userAgent;

    /* GOOGLE TAG MANAGER  */
    const gtmId = Configurations.REACT_APP_APP_GTM;

    if (gtmId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      if (
        !document.querySelector(
          `script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`,
        )
      ) {
        const gtmScript = document.createElement('script');
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        gtmScript.async = true;
        document.head.appendChild(gtmScript);
      }
    }

    /* BING UET (only on /app/registration) */
    if (pathname === '/app/registration') {
      (function (w: any, d: Document, t: string, r: string, u: string) {
        w[u] = w[u] || [];

        const loadUET = () => {
          const o: any = {
            ti: '97110000',
            enableAutoSpaTracking: true,
          };
          o.q = w[u];
          w[u] = new w.UET(o);
          w[u].push('pageLoad');
        };

        const script = d.createElement(t) as HTMLScriptElement;
        script.src = r;
        script.async = true;
        script.onload = loadUET;

        const firstScript = d.getElementsByTagName(t)[0];
        firstScript.parentNode!.insertBefore(script, firstScript);
      })(window, document, 'script', 'https://bat.bing.com/bat.js', 'uetq');
    }

    /* GOOGLE OPTIMIZE*/
    if (
      !document.querySelector(
        'script[src*="googleoptimize.com/optimize.js"]',
      )
    ) {
      const optimizeScript = document.createElement('script');
      optimizeScript.src =
        'https://www.googleoptimize.com/optimize.js?id=OPT-T9NDZSL';
      optimizeScript.async = true;
      document.head.appendChild(optimizeScript);
    }

    /* IE REDIRECT*/
    const isOldIE =
      userAgent.includes('MSIE ') || userAgent.includes('Trident/');

    if (isOldIE) {
      window.location.href = `${origin}/app/ienotsupported.html`;
      return;
    }

    /*  /app/agencies URL NORMALIZATION*/
    if (href.toLowerCase().includes('/app/agencies')) {
      let newUrl = href;
      let redirect = false;

      if (/[A-Z]/.test(newUrl)) {
        newUrl = newUrl.toLowerCase();
        redirect = true;
      }

      if (!newUrl.endsWith('/')) {
        newUrl += '/';
        redirect = true;
      }

      if (redirect) {
        window.location.replace(newUrl);
      }
    }
  }, []);

  return null;
};

export default TrackingAndRedirects;
